<template>
  <div class="base"></div>
</template>

<script>
export default {};
</script>

<style scoped>
base {
  width: 1774px;
  height: 680px;
  border-radius: 21px;
  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
}
</style>
